import React, { useEffect } from "react";
import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const SlideInOutSection = ({ children }) => {
  const controls = useAnimation();
  // Set triggerOnce to false so we can animate on every in/out event.
  const [ref, inView] = useInView({
    triggerOnce: false,
    threshold: 0.1, // Trigger when 10% of the section is visible
  });

  useEffect(() => {
    if (inView) {
      controls.start("visible");
    } else {
      controls.start("hidden");
    }
  }, [controls, inView]);

  const variants = {
    hidden: { opacity: 0, y: 50 }, // When out of view, slide down and fade out
    visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }, // When in view, slide up and fade in
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={controls}
      variants={variants}
    >
      {children}
    </motion.div>
  );
};

export default SlideInOutSection;
